module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"kpiAchievements":"KPI Achievements","actual":"Actual","lastYear":"Comparison Period","YoY":"Comparison%"}}')
  delete Component.options._Ctor
}
